import createReducer from "Common/reducerUtils/createReducer";
import omit from "lodash/omit";
import PROGRESS_STATES from "../requestProgressState";
import actionTypes from "./actionTypes";
const initialState = {};
export default createReducer(initialState, {
    [actionTypes.REQUEST_STARTED](state, action) {
        return {
            ...state,
            [action.scope]: { id: action.id, progressState: PROGRESS_STATES.INITIAL }
        };
    },
    [actionTypes.REQUEST_INPROGRESS](state, action) {
        const x = state[action.scope];
        return {
            ...state,
            [action.scope]: x && x.id === action.id ? { ...x, progressState: PROGRESS_STATES.INPROGRESS } : x
        };
    },
    [actionTypes.REQUEST_COMPLETED](state, action) {
        const x = state[action.scope];
        return x && x.id === action.id ? omit(state, action.scope) : state;
    },
    [actionTypes.REQUEST_REJECTED](state, action) {
        const x = state[action.scope];
        return x && x.id === action.id ? omit(state, action.scope) : state;
    }
});
